import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import MultipleTicker from "./components/MultipleTicker";
import Footer from "./components/Footer";
import { useColorBlindMode, useTemplateSetting } from "./hooks/useCompanySettings";
import MainContent from "./components/MainContent";
import { classNames } from "./utils";
import EurolandAverageBasedCalculatorModal from "./feat-average-based-calculator/components/AverageBasedCalculatorModal/AverageBasedCalculatorModal";
import { getBaseName } from "./utils/common";

function App() {
  const template = useTemplateSetting();
  const colorBlindMode = useColorBlindMode();
  useEffect(() => {
    const templateClass = `template-${template.toLocaleLowerCase()}`;
    document.body.classList.add(templateClass);
    document.body.setAttribute("dir", window.appSettings?.isRtl ? "rtl" : "ltr");
    return () => {
      document.body.classList.remove(templateClass);
      document.body.removeAttribute("dir");
    };
  }, [template]);
  return (
    <>
      <main
        className={classNames("main-app", {
          "color-blind-mode": colorBlindMode,
        })}
      >
        <MultipleTicker />
        <MainContent />
      </main>
      <Footer />
    </>

  );
}

function AppWrapper() {
  return (
    <BrowserRouter basename={getBaseName()}>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/average-based-calculator" element={<EurolandAverageBasedCalculatorModal />} />
      </Routes>
    </BrowserRouter>
  );
}

export default AppWrapper;
